//import firebase from 'firebase';
import 'firebase/firestore'
import 'firebase/storage'
import config from './firebaseConfig'


//const firebaseApp = firebase.initializeApp(config);
export default {
	instanceDB: config.firebaseApp.firestore().collection('OA_UAT'),
	eventDB: config.firebaseApp.firestore(),
	storageRef: config.firebaseApp.storage().ref(),
	Environment: config.Environment,
	SINGLEEMAILAPIURL: config.SINGLEEMAILAPIURL,
	BULKEMAILAPIURL: config.BULKEMAILAPIURL,
	DeleteAttendeeURL: config.DeleteAttendeeURL,
	DeleteAttendeeApiKey: config.DeleteAttendeeApiKey,
	S3GETVideoUploadURL: config.S3GETVideoUploadURL,
	S3GETVideoDownloadURL: config.S3GETVideoDownloadURL,
	S3LSGETVideoUploadURL: config.S3LSGETVideoUploadURL,
	S3GETLiveSessionInfo: config.S3GETLiveSessionInfo,
	S3SETVideoScheduleTime: config.S3SETVideoScheduleTime,
	DeleteCollectionApi: config.DeleteCollectionApi,
	FirebaseAuthApi: config.FirebaseAuthApi,
	EncryptedLoginURL: config.EncryptedLoginURL,
	MailactivityApi: config.MailactivityApi,
	MailactivityApiKey: config.MailactivityApiKey,
	GetsubcollectionsApi: config.GetsubcollectionsApi,
	CreateGroupAPI: config.CreateGroupAPI,
	GetsendpushApi: config.GetsendpushApi,
	GetGroupPushApi: config.GetGroupPushApi,
	sendpushApiKey: config.sendpushApiKey,
	SessionAttendeeMappingAPI: config.SessionAttendeeMappingAPI,
	GetAllTopicPushApi: config.GetAllTopicPushApi,
	GetSocialAuthToken: config.GetSocialAuthToken,
	//--------Debottam Da API for push-----------------------
	SendAttendeeAndGroupPushAPI: config.SendAttendeeAndGroupPushAPI,
	CloneEventAPI: config.CloneEventAPI,
	DeleteRoundTableAPI: config.DeleteRoundTableAPI,
	ZoomWSHostId: config.ZoomWSHostId,
	ZoomWSPassword: config.ZoomWSPassword,
    ZoomCreateMeetingAPI: config.ZoomCreateMeetingAPI,
    ZoomCreateUserAPI: config.ZoomCreateUserAPI,
    ZoomUserListAPI: config.ZoomUserListAPI,
	ZoomCreateWebinarAPI: config.ZoomCreateWebinarAPI,
	ZoomMakeWebinarHost: config.ZoomMakeWebinarHost,
    ZoomCreateUserHostAPI: config.ZoomCreateUserHostAPI,
    ZoomWebinarEnableRecordingAPI: config.ZoomWebinarEnableRecordingAPI,
    ZoomWebinarDisableRecordingAPI: config.ZoomWebinarDisableRecordingAPI,
	PageViewCountAPI: config.PageViewCountAPI,
	LoginSummaryAPI: config.LoginSummaryAPI,
	SessionTypeCountAPI: config.SessionTypeCountAPI,
	RoundTableTopicCountAPI: config.RoundTableTopicCountAPI,
	AllOverviewCountAPI: config.AllOverviewCountAPI,
	AllEngagementSummaryCountAPI: config.AllEngagementSummaryCountAPI,
	RegistraionSummaryCountAPI: config.RegistraionSummaryCountAPI,
	PageEngagementFetchAPI: config.PageEngagementFetchAPI,
	PageEngagementUserWiseFetchAPI: config.PageEngagementUserWiseFetchAPI,
	PageEngagementUserSpecificDataFetchAPI: config.PageEngagementUserSpecificDataFetchAPI,
	LoginSummaryFetchAPI:  config.LoginSummaryFetchAPI,
	UserJourneyTopLevelFetchAPI: config.UserJourneyTopLevelFetchAPI,
	UserSpecificJourneyFetchAPI: config.UserSpecificJourneyFetchAPI,
	MeetingConfigAPI: config.MeetingConfigAPI,
	MeetingListAPI: config.MeetingListAPI,
	MeetingAcceptAPI: config.MeetingAcceptAPI,
    MeetingRejectAPI: config.MeetingRejectAPI ,
    MeetingCancelAPI: config.MeetingCancelAPI,
	MeetingDeleteAPI: config.MeetingDeleteAPI,
	MeetingDeleteAPI2: config.MeetingDeleteAPI2,
	FetchLiveVisitorDataAPI: config.FetchLiveVisitorDataAPI,
	ResetPasswordForUserAPI: config.ResetPasswordForUserAPI,
	FetchExhibitorVisitoReportAPI: config.FetchExhibitorVisitoReportAPI,
	CreateRTMPSession: config.CreateRTMPSession,
	ZoomEnableRTMPmeeting: config.ZoomEnableRTMPmeeting,
	ZoomEnableMeetingRecordingAPI: config.ZoomEnableMeetingRecordingAPI,
	UniqueLoginSummaryFetchAPI: config.UniqueLoginSummaryFetchAPI,
	ZoomEnableBreakout: config.ZoomEnableBreakout,
    ZoomDisableBreakout: config.ZoomDisableBreakout,
    ZoomCoHostAPI: config.ZoomCoHostAPI,
	ZoomMeetingAnalytics: config.ZoomMeetingAnalytics,
	ZoomWebinarAnalytics: config.ZoomWebinarAnalytics,
	SponserVisitFetchAPI: config.SponserVisitFetchAPI,
	FetchAllUserActionByPageNameOrUserId: config.FetchAllUserActionByPageNameOrUserId,
	AddSingleAttendeeAPI: config.AddSingleAttendeeAPI,
	AddMultipleAttendeeAPI: config.AddMultipleAttendeeAPI,
	AddAttendeeAPI: config.AddAttendeeAPI,
	GetPlanUssage: config.GetPlanUssage,
	RecordedVideoUrlsAPI: config.RecordedVideoUrlsAPI,
	LivePanelToOnDemandVideoAPI: config.LivePanelToOnDemandVideoAPI,
	EndCallAPI: config.EndCallAPI,
	FetchAllDashboardStatsAPI: config.FetchAllDashboardStatsAPI,
	AddSpeakerAPI: config.AddSpeakerAPI,
	ResourceDeleteAPI: config.ResourceDeleteAPI,
	MeetingCountAPI: config.MeetingCountAPI,
	BusinessCardFetchAPI: config.BusinessCardFetchAPI,
	CreateEventAPI: config.CreateEventAPI,
	UpdateUserDataAPI: config.UpdateUserDataAPI,
    CheckUserValidAPI: config.CheckUserValidAPI,
    FetchAllAdmins: config.FetchAllAdmins,
    UpdateUserAPI: config.UpdateUserAPI,
    ClientAddAPI: config.ClientAddAPI,
	ClientEditAPI: config.ClientEditAPI,
	AddSessionAPI: config.AddSessionAPI,
	UploadFilesAPI: config.UploadFilesAPI,
	UserEventsAPI: config.UserEventsAPI,
	SchedulingAPI: config.SchedulingAPI,
	DeleteSchedulingAPI: config.DeleteSchedulingAPI,
	StartNotificationSendAPI: config.StartNotificationSendAPI,
	RoundTableWriteAPI: config.RoundTableWriteAPI,
	LeaderBoardGetActions: config.LeaderBoardGetActions,
	LeaderBoardSetActions: config.LeaderBoardSetActions,
	LeaderBoardClearScore: config.LeaderBoardClearScore,
	GetSessionBatch: config.GetSessionBatch,
	CreateChatGroup: config.CreateChatGroup,
	EditCHatGroup: config.EditCHatGroup,
	SearchAttendees: config.SearchAttendees,
	GetLeaderBoardConfig: config.GetLeaderBoardConfig,
	SetLeaderBoardConfig: config.SetLeaderBoardConfig,
	DeleteUserFromRoom: config.DeleteUserFromRoom,
	LeaderBoardClearItems: config.LeaderBoardClearItems,
	UnpublishMessage: config.UnpublishMessage,
	RequestMultipleMeeting: config.RequestMultipleMeeting,
	PostChatMessage: config.PostChatMessage,
	TranslateChatMessage: config.TranslateChatMessage,
	LeaderBoardGetAllUsers: config.LeaderBoardGetAllUsers,
	LeaderBoardGetAllActions: config.LeaderBoardGetAllActions,
	LeaderBoardGetScore: config.LeaderBoardGetScore,
	CreateCustomRoomActivity: config.CreateCustomRoomActivity,
	CreateNewGame: config.CreateNewGame,
	LeaderBoardBulkActivity: config.LeaderBoardBulkActivity,
	LeaderBoardSetScavenges: config.LeaderBoardSetScavenges,
	LeaderBoardGameScores: config.LeaderBoardGameScores,
	MeetingStat: config.MeetingStat,
	O2OZoomAdapter: config.O2OZoomAdapter,
	GetChatStats: config.GetChatStats,
	BroadcastRoomMessage: config.BroadcastRoomMessage,
	GetRoomStats: config.GetRoomStats,
	getBoothStats: config.getBoothStats,
	getEventStats: config.getEventStats,
	getAllSessions: config.getAllSessions,
	exhibitorMeeting: config.exhibitorMeeting,
	getCollectionDocsAPI: config.getCollectionDocsAPI,
	getSingleDocAPI: config.getSingleDocAPI,
	regFormAPI: config.regFormAPI,
	getTurnoutCounts: config.getTurnoutCounts,
	getExhibitorStats: config.getExhibitorStats,
	getAllRegUseridsAPI: config.getAllRegUseridsAPI,
	getAllActiveUseridsAPI: config.getAllActiveUseridsAPI,
	getAllInactiveUseridsAPI: config.getAllInactiveUseridsAPI,
	getCurrentSessionParticipants: config.getCurrentSessionParticipants,
	getAllFloorMapsAPI: config.getAllFloorMapsAPI,
	getFloorMapDetailAPI: config.getFloorMapDetailAPI,
	saveFloorMapAPI: config.saveFloorMapAPI,
	saveRegistrationTypeAPI: config.saveRegistrationTypeAPI,
	saveCheckoutFormAPI: config.saveCheckoutFormAPI,
	getAllBoothMapsAPI: config.getAllBoothMapsAPI,
	getBoothMapDetailAPI: config.getBoothMapDetailAPI,
	saveBoothMapAPI: config.saveBoothMapAPI,
	getAllRootMapsAPI: config.getAllRootMapsAPI,
    getRootMapDetailAPI: config.getRootMapDetailAPI,
    saveRootMapAPI: config.saveRootMapAPI,
    BULKMAILAPINEW: config.BULKMAILAPINEW,
    getGoogleSheetRows: config.getGoogleSheetRows,
    getJoinURLAPI: config.getJoinURLAPI,
    rptsession: config.rptsession,
    generateQR: config.generateQR,
	// For Geo Checkin htx cms
	GeoCheckinCMS: config.GeoCheckinCMS,
	checkinLocationFetchAPi: config.checkinLocationFetchAPi,
	resourceBaseUrl: config.resourceBaseUrl,
	googleMapApiKey: config.googleMapApiKey,
	checkinRoleFetchAPi: config.checkinRoleFetchAPi,
	checkinLocationAddAPi: config.checkinLocationAddAPi,
	checkinRoleAddAPi: config.checkinRoleAddAPi,
	checkinSettingsFetchAPi: config.checkinSettingsFetchAPi,
	ResetPasswordForCheckinUserAPI: config.ResetPasswordForCheckinUserAPI,
	autoEmailDomainPrefix: config.autoEmailDomainPrefix,
	ReportForCheckinAPI: config.ReportForCheckinAPI,
	defaultPassword: config.defaultPassword,
	scheduleGlobalCheckout: config.scheduleGlobalCheckout,
    designationFetchAPi: config.designationFetchAPi,
    designationSaveAPi: config.designationSaveAPi,
}